<template>
  <div class="py-4 px-4">
    <highcharts :options="chartOptions"></highcharts>
  </div>

</template>

<script>

export default {
  props:
  {
    legenda: String,
    unidadeMedida: String,
    dados: Array,
    tipo: {
      type: String,
      default: 'column'
    },
  },
  data() {

    return {
      chartOptions: {
        chart: {
          type: 'bar'
        },
        title: {
          text: 'Stacked bar chart'
        },
        xAxis: {
          categories: ['São Luís', 'Marabá', 'Nova Iguaçu', 'Bahia', 'São Paulo']
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Solicitação tempo de atendimento'
          }
        },
        legend: {
          reversed: true
        },
        plotOptions: {
          series: {
            stacking: 'normal'
          }
        },
        series: [{
          name: 'Aprovação',
          data: [2, 2, 3, 2, 1]
        }, {
          name: 'Atendida',
          data: [3, 4, 4, 2, 5]
        }, {
          name: 'Aprovação',
          data: [5, 3, 4, 7, 2]
        },]
      }
    }

  }
}
</script>
